/* eslint-env browser */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';
import ClientSideConfigSelector from '../../../../recoil/cashout/ClientSideConfigSelector';
import useHttpRequest from '../../../api/HttpRequest';

// todo: need to think about refactoring, no needed to fetch URL on every render,
//  but only when user clicks the button
export default function CashoutKycModalContent({ onContinue, onClose }) {
  const { t } = useTranslation();
  const httpRequest = useHttpRequest();

  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        paymentProvider,
        isOpeningLinksInNewWindowSupported = false,
        displayProviderRegistrationCopyUrl = false,
      } = {},
    } = {},
  } = config || {};

  const [verificationUrl, setVerificationUrl] = useState(null);
  const [verificationUrlCopy, setVerificationUrlCopy] = useState(null);
  const [verificationOpened, setVerificationOpened] = useState(false);

  const handleCopyLink = () => {
    if (verificationUrl) {
      navigator.clipboard.writeText(verificationUrl);
      setVerificationUrlCopy(verificationUrl);
    }
  };

  const fetchVerificationUrl = async () => {
    try {
      const result = await httpRequest.send(`/web-payments/cash-reward/kyc/${paymentProvider}/initiate`, {
        method: 'POST',
      });
      setVerificationUrl(result.verificationURL);
      console.log('verification URL: ', result);
    } catch (err) {
      console.log('Unable to fetch a verification URL', err);
    }
  };

  useEffect(() => {
    fetchVerificationUrl();
    // eslint-disable-next-line
  }, [paymentProvider]);

  return (
    <div
      id="cashout-verify-account"
      className="phoenix-simple-dialog-view modal member-diamonds-cash-confirm show"
      aria-hidden="false"
    >
      <div className="modal-backdrop fade in" />
      <div className="modal-dialog">
        <div className="modal-content modal-content-sw">
          <div className="modal-header">
            <a
              className="close phoenix-icon phoenix-icon-cross hidden-xs hidden-sm"
              onClick={onClose}
              aria-hidden="true"
            />
            <h4>{t('cashout_verify_account')}</h4>
          </div>

          <div className="modal-body">
            <div>{t('cashout_verify_account_modal_body')}</div>

            {verificationUrlCopy && (
              <div className="text-center copy-url-text" style={{ color: 'red' }}>
                  {t('copied_verify_url_message')}
              </div>
            )}
          </div>

          <div className="modal-footer">
            <div className="btn-row">
              {/* Cancel button */}
              <button
                type="button"
                className="btn btn-undesired btn-cashout-cancel"
                aria-hidden="true"
                onClick={onClose}
              >
                {t('cashout_cancel')}
              </button>

              {/* Conditional section */}
              {displayProviderRegistrationCopyUrl ? (
                <button
                  id="verify-account-button"
                  type="button"
                  className="btn btn-primary copy-url-button"
                  aria-hidden="true"
                  disabled={!verificationUrl}
                  onClick={handleCopyLink}
                >
                  {verificationUrlCopy ? (
                    <div className="provider-register-link-url-copied">
                      {t('cashout_verify_account_link_copied')}
                    </div>
                  ) : (
                    <div className="provider-register-link-url">
                      {t('cashout_verify_account')}
                    </div>
                  )}
                </button>
              ) : (
                <a
                  id="verify-account-button"
                  type="button"
                  className={`btn btn-primary ${!verificationUrl ? 'disabled' : ''}`}
                  href={verificationUrl || '#'}
                  target={isOpeningLinksInNewWindowSupported ? '_blank' : undefined}
                  rel={isOpeningLinksInNewWindowSupported ? 'noopener noreferrer' : undefined}
                  onClick={(e) => {
                    if (!verificationUrl) {
                      e.preventDefault();
                      return;
                    }
                    setVerificationOpened(true);
                  }}
                >
                  {t('cashout_verify_account')}
                </a>
              )}

              {!displayProviderRegistrationCopyUrl && (
                <button
                  id="verify-account-continue"
                  type="button"
                  className="btn btn-success btn-cashout-continue"
                  aria-hidden="true"
                  disabled={!verificationOpened}
                  onClick={() => {
                    onContinue();
                    onClose();
                  }}
                >
                  {t('cashout_continue')}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CashoutKycModalContent.propTypes = {
  onContinue: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
